import { SettingGroupObjectType } from '@/interfaces/settingGroupObjectType';

import { EntityResource } from './entity.resource';

/**
 * Resource grupy ustawienia
 *
 * @export
 * @class SettingGroupResource
 * @extends {EntityResource<SettingGroupObjectType>}
 */
export class SettingGroupResource extends EntityResource<SettingGroupObjectType> {
  public getFields = {
    id: true,
    name: true
  };
  public listFields = {
    id: true,
    name: true
  };

  constructor() {
    super({ entityName: 'settingGroup' });
  }
}

export const settingGroupResource = new SettingGroupResource();
